import { defineStore } from "pinia";

export const useDarkModeStore = defineStore("darkMode", {
    state: () => ({
        darkMode: false,
    }),
});
